import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=de1e1ac4&scoped=true&"
import script from "./LogoutBtn.vue?vue&type=script&lang=ts&"
export * from "./LogoutBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1e1ac4",
  null
  
)

export default component.exports